export const FigureAddService = Symbol.for('FigureAddService');

export interface FigureData {
    /** 图片URL */
    url: string;
    s3Key: string;
    uniqueId: string;
}

/**
 * 处理添加图形到规范说明书的服务
 */
export interface FigureAddService {
    /**
     * 批量添加图形到规范说明书中
     * @param images 图片信息数组
     */
    addFigures(images: FigureData[]): void;
}
